import {get} from "cartovistaExtend/appTools/Alerts";
import AuthSession from "cartovistaExtend/appTools/AuthSession";
import { Modal } from 'bootstrap';
import "../styles/AuthSessionExtend.css";

var logoutWarningModalHtml = '<div id="AuthSessionExtend_logoutWarningModal" class="modal fade" tabindex="-1" role="dialog" data-bs-backdrop="static">' +
                                    '<div class="modal-dialog modal-sm" role="document">' +
                                        '<div class="modal-content">' +
                                            '<div class="modal-body">' +
                                                '<h5 style="margin-bottom:20px;">' + get("AuthSession_LogoutWarning") + '</h5>' +
                                                '<p>Une ou plusieurs descriptions n\'ont pas été sauvegardées. Voulez-vous quitter l\'application sans les sauvegarder?</p>' +
                                                '<div class="clearfix">' +
                                                    '<div class="btn-group pull-right">' +
                                                        '<button id="AuthSessionExtend_logoutAcceptBtn" type="button" class="btn btn-primary btn-sm" data-dismiss="modal" aria-label="Accept">Quitter</button>' +
                                                        '<button id="AuthSessionExtend_logoutCancelBtn" type="button" class="btn btn-default btn-sm" data-dismiss="modal" aria-label="Close">Annuler</button>' +
                                                    '</div>' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>';

var userRoleContainer = '<div id="AuthSessionExtend_userRoleContainer"></div>';

export default class AuthSessionExtend extends AuthSession {
    constructor(){
        super();
        this._$logoutWarningModal = $(logoutWarningModalHtml);
        this._$logoutAcceptBtn = this._$logoutWarningModal.find("#AuthSessionExtend_logoutAcceptBtn");
        this._$logoutAcceptBtn.click(this._onLogoutAcceptBtnClicked.bind(this));
        this._$userRoleContainer = $(userRoleContainer);
        $(".cv-header-left > div:nth-child(2)").after(this._$userRoleContainer);
        this._setUserRoleContainerValue();
        window.cartovista.addEventListener("AuthSession_UserLoggedIn", this._setUserRoleContainerValue, this);
    }

    _onLogoutAcceptBtnClicked() {
        this._logout();
    };

    _onLogoutBtnClicked() {
        var sectorsData = window.sectorsDataStore.getSectorsData();
        if (_.some(sectorsData, {"descriptionDirty" : true})) {
            new Modal(this._$logoutWarningModal).show();
        } else {
            this._$logoutBtn.prop("disabled", true);
            this._logout();
        }
    };

    _setUserRoleContainerValue() {
        if (C.APP_TOOLS.AUTH_SESSION.USER.EDITION_ALLOWED) {
            this._$userRoleContainer.html("<em>(Mode édition)</em>");
        } else {
            this._$userRoleContainer.html("<em>(Mode lecture seule)</em>");
        }
    };
   }
